export default __webpack_public_path__ + "static/image7-9c19a881e6d70b94a6738a44b1a99a8e.gif";